import { ref, watch } from 'vue'
import { useLoadMapWidget } from './api'

const useModel = () => {
  const center = ref([30.3351, 59.9343])
  const zoom = ref(16)
  const full = ref(false)

  const marker = ref<{ longitude: number; latitude: number }>({
    longitude: 0,
    latitude: 0,
  })

  const loadData = () => {
    const result = useLoadMapWidget()

    watch(result.data, () => {
      if (result.data) {
        if (result.data.value) {
          marker.value = result.data.value.data
          center.value = [
            marker.value.longitude || center.value[0],
            marker.value.latitude || center.value[1],
          ]
        }
      }
    })

    return { ...result }
  }

  return {
    center,
    zoom,
    full,
    marker,

    loadData,
  }
}

export default useModel
